const parse_param = (param) => {
  return param.replaceAll(' ', '_').toLowerCase();
};

const isReferenceDesignator = (param) => {
  const ref_des = [
    'reference_designator',
    'ref_designator',
    'ref_des',
    'designator',
    'refdes',
  ];

  return ref_des.includes(param);
};

const isManufacturerPartNumber = (param) => {
  const mfg_part = [
    'manufacturer_part_number',
    'mfg_part_number',
    'mfg_part',
    'mfg_part_#',
    'mfr_part_#',
    'part_number',
    'pn',
    'name',
  ];

  return mfg_part.includes(param);
};

const isManufacturer = (param) => {
  const mfg = ['manufacturer', 'mfg', 'mfr'];

  return mfg.includes(param);
};

const isVendorPartNumber = (param) => {
  const vendor_part = [
    'vendor_part_number',
    'vendor_part',
    'vendor_part_#',
    'distributor_part_number',
    'distributor_part',
    'distributor_part_#',
  ];

  return vendor_part.includes(param);
};

const isVendor = (param) => {
  const vendor = ['vendor', 'distributor'];

  return vendor.includes(param);
};

const isQuantity = (param) => {
  const qty = ['quantity', 'qty', 'qty_per_board'];

  return qty.includes(param);
};

const isDescription = (param) => {
  const desc = ['description', 'desc'];

  return desc.includes(param);
};

const isDNP = (param) => {
  const dnp = ['dnp', 'do_not_populate', 'do_not_place'];

  return dnp.includes(param);
};

const isParamHeader = (param) => {
  if (!param || _.isNumber(param)) return false;
  const parsed_param = parse_param(param);

  return (
    isReferenceDesignator(parsed_param) ||
    isManufacturerPartNumber(parsed_param) ||
    isManufacturer(parsed_param) ||
    isVendorPartNumber(parsed_param) ||
    isVendor(parsed_param) ||
    isQuantity(parsed_param) ||
    isDescription(parsed_param) ||
    isDNP(parsed_param)
  );
};

const isRowHeader = (row) => {
  return row.find((param) => isParamHeader(param)) != undefined;
};

export const findRowHeader = (rows) => {
  return rows.findIndex((row) => isRowHeader(row));
};

export const getParamValue = (param) => {
  const parsed_param = parse_param(param);

  if (isReferenceDesignator(parsed_param)) return 'reference_designator';
  if (isManufacturerPartNumber(parsed_param)) return 'mpn';
  if (isManufacturer(parsed_param)) return 'manufacturer';
  if (isVendorPartNumber(parsed_param)) return 'vendor_part';
  if (isVendor(parsed_param)) return 'vendor';
  if (isQuantity(parsed_param)) return 'qty_per_board';
  if (isDescription(parsed_param)) return 'description';
  if (isDNP(parsed_param)) return 'dnp';

  return '';
};
